<template>
	<div class="container">
		<div class="form_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="form_box_el">
				<div class="form_el form_left">
					<div class="label">First name<span>*</span></div>
					<div class="input_el">
						<input v-model="firstVal" :class="isClick && !firstVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !firstVal" class="error">Please complete this required field.</div>
				</div>
				<div style="width: 4%;"></div>
				<div class="form_el form_right">
					<div class="label">Last name<span>*</span></div>
					<div class="input_el">
						<input v-model="lastVal" :class="isClick && !lastVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !lastVal" class="error">Please complete this required field.</div>
				</div>
			</div>
			<div class="form_box_el">
				<div class="form_el form_left">
					<div class="label">Organization<span>*</span></div>
					<div class="input_el">
						<input v-model="organizationVal" :class="isClick && !organizationVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !organizationVal" class="error">Please complete this required field.</div>
				</div>
				<div style="width: 4%;"></div>
				<div class="form_el form_right">
					<div class="label">Title<span>*</span></div>
					<div class="input_el">
						<input v-model="titleVal" :class="isClick && !titleVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !titleVal" class="error">Please complete this required field.</div>
				</div>
			</div>
			<div class="form_box_el">
				<div class="form_el form_left">
					<div class="label">Email<span>*</span></div>
					<div class="input_el">
						<input v-model="emailVal" :class="isClick && !emailVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !emailVal" class="error">Please complete this required field.</div>
				</div>
				<div style="width: 4%;"></div>
				<div class="form_el form_right">
					<div class="label">Phone number<span>*</span></div>
					<div class="input_el">
						<input v-model="phoneVal" :class="isClick && !phoneVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !phoneVal" class="error">Please complete this required field.</div>
				</div>
			</div>
			<div class="form_el">
				<div class="label">How can we help you today?<span>*</span></div>
				<div class="input_el">
					<textarea v-model="helpVal" :class="isClick && !helpVal ? 'err' : ''" style="height: 80px;line-height: 20px;"></textarea>
				</div>
				<div v-show="isClick && !helpVal" class="error">Please complete this required field.</div>
			</div>
			<div v-show="isClick && !lastVal && !firstVal && !organizationVal && !titleVal && !emailVal && !phoneVal && !helpVal" class="tips_box">
				<div class="error">Please complete all required fields.</div>
			</div>
			<div style="padding-top: 30px;text-align: center;">
				<div class="btn_box" @click="subClick">Submit</div>
			</div>
		</div>
	</div>
</template>

<script>
import { formProductSubmit } from '@/api/public';
export default {
	components:{
		//
	},
	props: ['type'],
	data() {
		return {
			emailVal: '',
			firstVal: '',
			lastVal: '',
			organizationVal: '',
			titleVal: '',
			phoneVal: '',
			helpVal: '',
			isClick: false,
			productType: this.type,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal && that.organizationVal && that.titleVal && that.phoneVal && that.helpVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				let productName = 'Cordx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test';
				if(that.productType == 2) {
					productName = 'CorDx Tyfast Flu A/B & COVID-19 At Home Multiplex Rapid Test';
				}
				formProductSubmit({
					product_name: productName,
					first_name: that.firstVal,
					last_name: that.lastVal,
					organization: that.organizationVal,
					title: that.titleVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					content: that.helpVal,
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.organizationVal = '';
					that.titleVal = '';
					that.phoneVal = '';
					that.helpVal = '';
					that.isClick = false;
				});
			}
		},
	}
}
</script>

<style lang="less" scoped>
.form_box{
	.btn_box{
		display: inline-block;
		margin-top: 0px;
		padding: 6px 20px;
		background: #0B318F;
		border-color: #0B318F;
		color: #ffffff;
		//font-weight: bold;
		font-family: helvetica;
		cursor: pointer;
	}
	.tips_box{
		margin-top: 20px;
		.error{
			font-size: 13px;
			font-family: helvetica;
			color: #f2545b;
		}
	}
	.form_box_el{
		display: flex;
		.form_left{
			flex: 1;
		}
		.form_right{
			flex: 1;
		}
	}
	.form_el{
		width: 100%;
		margin-top: 15px;
		.input_el{
			input, textarea, select{
				width: 100%;
				height: 40px;
				line-height: 40px;
				padding: 9px 10px;
				background-color: #f5f8fa;
				color: #33475b;
				border: 1px solid #cbd6e2;
			}
			input.err{
				border: 1px solid #c87872;
			}
			select.err{
				border: 1px solid #c87872;
			}
		}
		.label{
			font-size: 13px;
			font-family: helvetica;
			color: #0B318F;
			span{
				color: #f2545b;
			}
		}
		.error{
			font-size: 13px;
			font-family: helvetica;
			color: #f2545b;
		}
	}
}
</style>